import React from 'react';
import { Author } from '@/types/blog/single';
import Link from 'next/link';
import Image from 'next/image';

interface PostAuthorProps {
    author?: Author;
    className?: string;
}

const PostAuthor: React.FC<PostAuthorProps> = ({ author, className }) => {
    return (
        <Link
            prefetch={false}
            href={author?.node?.uri || '#'}
            className={`flex items-center gap-1 ${className}`}
        >
            <Image
                loading={'lazy'}
                width={32}
                height={32}
                sizes='32px'
                className={'lg:size-8 size-7 rounded-full'}
                alt={author?.node?.name || 'author'}
                title={author?.node?.name}
                src={author?.node?.avatar?.url ? author?.node?.avatar?.url : '/logo-vector.svg'}
            />
            <div className={'max-lg:pb-2 '}>
                <div
                    className={
                        'lg:text-xs text-[10px] font-light text-primary/85 dark:text-white/85'
                    }
                >
                    نویسنده
                </div>
                <div className={'lg:text-xs text-[10px] underline underline-offset-4'}>
                    {author?.node?.name}
                </div>
            </div>
        </Link>
    );
};

export default PostAuthor;
